export const defaultLoader = [
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    }
]

interface Totalizer {
    quantidadeTotal: number
    totalValorRegistradora: number
    totalTaxaRegistro: number
}

interface TotalizerSummary {
    quantidadeTotal: number
    valorRegistradoraTotal: number
    taxaRegistroTotal: number
}

type CombinedTotalizers = Array<Totalizer> & TotalizerSummary

export const getTotalizerBoxes = (totalizers?: CombinedTotalizers) => {
    return [
        {
            descricao: 'Total de Inclusão de Contrato',
            quantidadeTotal: totalizers?.[0]?.quantidadeTotal ?? 0,
            totalRegistradora: totalizers?.[0]?.totalValorRegistradora ?? 0,
            totalTaxaRegistro: totalizers?.[0]?.totalTaxaRegistro ?? 0
        },
        {
            descricao: 'Total de Inclusão de Aditivo',
            quantidadeTotal: totalizers?.[1]?.quantidadeTotal ?? 0,
            totalRegistradora: totalizers?.[1]?.totalValorRegistradora ?? 0,
            totalTaxaRegistro: totalizers?.[1]?.totalTaxaRegistro ?? 0
        },
        {
            descricao: 'Resultado Financeiro',
            quantidadeTotal: totalizers?.quantidadeTotal ?? 0,
            totalRegistradora: totalizers?.valorRegistradoraTotal ?? 0,
            totalTaxaRegistro: totalizers?.taxaRegistroTotal ?? 0
        }
    ]
}
